// utm_data 쿠키 Domain 설정을 위한 BaseDomain 추출 함수
export const getBaseDomain = (): string => {
  if (window.location.hostname === "localhost") {
    return "";
  }

  const domain = window.location.hostname.split(".");

  if (domain.length > 2) {
    return domain.slice(-2).join(".");
  }

  return "";
};
